/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Avatar from "uis/avatar";
import { theme } from "styles/theme";

const HostProfile = ({
  image,
  name,
  email,
  onDelete,
}: {
  image: string;
  name: string;
  email: string;
  onDelete?: () => void;
}) => {
  return (
    <div
      css={css`
        display: flex;
        gap: 20px;
        align-items: center;
        padding: 8px 24px;
        border-bottom: 1px solid ${theme.neutral100};
      `}
    >
      <div
        css={css`
          display: flex;
          gap: 12px;
          width: 160px;
          align-items: center;
        `}
      >
        <Avatar image={image} />
        <p
          css={css`
            color: ${theme.neutral900};
            font-weight: 500;
            font-size: 14px;
          `}
        >
          {name}
        </p>
      </div>
      <p
        css={css`
          color: ${theme.neutral500};
          font-weight: 400;
          font-size: 14px;
        `}
      >
        {email}
      </p>

      <p
        onClick={onDelete}
        css={css`
          color: ${theme.primary500};
          margin-left: 40px;
          font-weight: 600;
          font-size: 14px;
          margin-left: auto;
          cursor: pointer;
          &:hover {
            font-weight: 800;
          }
        `}
      >
        삭제하기
      </p>
    </div>
  );
};

export default HostProfile;
